/* bai-mobile : comportements telephone. */
(function(){
  "use strict";
  var reduit=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Points de position sous les carrousels de la fiche machine. */
  Array.prototype.forEach.call(document.querySelectorAll(".bai-produire .steps, .bai-feats .feat-3"),function(list){
    var n=list.children.length;
    if(n<2)return;
    var dots=document.createElement("div"),btns=[],raf=null;
    dots.className="bai-dots";
    function pas(){return list.children[1].offsetLeft-list.children[0].offsetLeft}
    function go(i){list.scrollTo({left:i*pas(),behavior:reduit?"auto":"smooth"})}
    function maj(){
      raf=null;
      var p=pas(),i=p>0?Math.round(list.scrollLeft/p):0;
      i=Math.max(0,Math.min(n-1,i));
      btns.forEach(function(b,j){j===i?b.setAttribute("aria-current","true"):b.removeAttribute("aria-current")});
    }
    for(var i=0;i<n;i++){
      (function(i){
        var b=document.createElement("button");
        b.type="button";
        b.className="bai-dot";
        b.setAttribute("aria-label",(i+1)+" / "+n);
        b.addEventListener("click",function(){go(i)});
        dots.appendChild(b);
        btns.push(b);
      })(i);
    }
    list.parentNode.insertBefore(dots,list.nextSibling);
    list.addEventListener("scroll",function(){raf||(raf=requestAnimationFrame(maj))},{passive:true});
    window.addEventListener("resize",maj);
    maj();
  });

  /* Barre d'achat du bas (fiche produit) : elle se cache seulement quand le vrai
     bouton Add to cart est a l'ecran, ou elle ferait doublon. bai.js la cachait
     pour n'importe quel formulaire d'achat de la page (data-vue) ; la regle CSS
     de bai-mobile.css neutralise ce cas et ne retient que data-haut. */
  var barre=document.querySelector(".barre-bas"),achat=document.querySelector("[data-fi-add]");
  if(barre&&achat&&"IntersectionObserver" in window){
    new IntersectionObserver(function(es){
      barre.setAttribute("data-haut",es[es.length-1].isIntersecting?"true":"false");
    }).observe(achat);
  }

  /* Video du heros d'accueil (bai-hero.liquid). Certains telephones refusent de la lancer toute seule (iPhone en
     mode economie d'energie, navigateur integre a une application). Dans ce cas on affiche quand meme une image
     de la video (poster) au lieu de rien, et la video demarre au premier toucher ou defilement de la page. */
  var hv=document.querySelector(".hero-video video"),hd=hv&&hv.parentNode;
  if(hv&&!reduit&&window.matchMedia("(max-width: 900px)").matches){
    var essais=0;
    var lancer=function(){
      if(!hv.src||!hv.paused)return;
      var p=hv.play();
      if(p&&p.then)p.then(function(){hd.classList.add("est-pret")}).catch(function(){});
    };
    var verifier=function(){
      if(!hv.src){if(++essais<8)setTimeout(verifier,500);return;}
      if(hv.paused){
        if(!hv.getAttribute("poster"))hv.setAttribute("poster","https://cdn.shopify.com/s/files/1/1007/5907/7196/files/bai-hero-mobile-poster.jpg?v=1791541511");
        hd.classList.add("est-pret");
        ["touchstart","pointerdown","scroll"].forEach(function(e){window.addEventListener(e,lancer,{passive:true,once:true})});
      }
    };
    if(document.readyState==="complete")setTimeout(verifier,2200);
    else window.addEventListener("load",function(){setTimeout(verifier,2200)});
  }
})();
